<footer>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-3 footer-col">
        <img
          ngSrc="assets/preneed/white-logo.png"
          alt="logo"
          width="175"
          height="72"
          class="footer-white-logo"
        />
        <div class="social-icons">
          <img width="35" height="35" src="assets/new-icons/pinterest.svg" />
          <img width="35" height="35" src="assets/new-icons/linkedin.svg" />
          <img width="35" height="35" src="assets/new-icons/instagram.svg" />
          <img width="35" height="35" src="assets/new-icons/whatsapp.svg" />
          <img width="35" height="35" src="assets/new-icons/telegram.svg" />
        </div>
        <div class="contact-us-part">
          <span>تماس با پشتیبانی: </span>
          <a href="tel:+982191691030" class="call-link">021-9169 10 30</a>
        </div>
      </div>
      <div class="col-12 col-md-3 footer-col py-2 my-auto">
        <a routerLink="/user"> ناحیه کاربری </a>
        <a routerLink="/contact-us"> تماس با ما </a>
        <a href="http://"> زیراکسی مگ </a>
      </div>
      <div class="col-12 col-md-3 footer-col py-2 my-auto">
        <a routerLink="/price-list"> تعرفه‌ها</a>
        <a routerLink="/faq"> سوالات متداول </a>
        <a routerLink="user/my-orders"> پیگیری سفارش </a>
      </div>
      <div class="col-12 col-md-3 footer-col py-2 my-auto">
        <div class="subscribe-wrapper">
          <div class="subscribe-title">
            <mat-icon svgIcon="mail-plus" class="white"></mat-icon>
            برای عضویت در خبرنامه زیراکسی و اطلاع از تخفیفات، ایمیل خود را ثبت
            کنید.
          </div>
          <div class="email-wrapper">
            <button class="btn button-danger">عضویت در خبرنامه</button>
            <input dir="ltr" placeholder="moein@gmail.com" type="text" />
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md-8">
            <div
              class="mt-4 position-relative footer-text-wrapper"
              [ngClass]="{ 'full-footer': showMore }"
            >
              <span class="footer-title">سامانه چاپ آنلاین زیراکسی</span>
              <div #footer class="footer-container">
                <ng-content></ng-content>
              </div>
              <div class="footer-container" *ngIf="!footer.innerHTML.trim()">
                <p class="text-justify">
                  سفارش چاپ آنلاین مطمئن، نیازمند چاپخانه‌ای است که بتواند خدمات
                  متنوع چاپ را با بالا‌ترین کیفیت و مناسب‌ترین قیمت، به مخاطبان
                  خود ارائه کند و سفارش‌ها را در کم‌ترین زمان ممکن به دست
                  مشتریان برساند.
                  <br />
                  زیراکسی مجموعه‌ای پویا و پیشرو در زمینه چاپ افست و چاپ دیجیتال
                  است که تمامی خدمات خود را به‌صورت آنلاین به مشتریان ارائه
                  می‌کند. این شرکت با تکیه بر نیروهای متخصص و مجرب و همچنین
                  چاپخانه‌ای پیشرفته، انقلابی بزرگ در حوزه چاپ آنلاین ایجاد کرده
                  است. زیراکسی با ارائه خدماتی کم‌نظیر و باکیفیت، توانسته توجه و
                  اعتماد کاربران زیادی را جلب و آن‌ها را به مشتریان ثابت خود
                  تبدیل کند.
                </p>
              </div>
              <div class="footer-show-more">
                <span
                  class="text-center show-more-btn"
                  (click)="showMore = !showMore"
                >
                  <ng-container *ngIf="!showMore">مشاهده بیشتر</ng-container>
                  <ng-container *ngIf="showMore">مشاهده کمتر</ng-container>
                  <mat-icon svgIcon="chevron-down" class="white"></mat-icon>
                </span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="external-icon-wrapper">
              <img src="assets/image/enamad-logo.png" />
              <img src="assets/image/resane.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
